import classNames from 'classnames';
import { PulseCircleAnimationMode, PlanType } from 'enums';
import { motion } from 'framer-motion';
import { RootStore, withInjectedRootStore } from 'providers';
import { usePageModeContext } from 'providers/PageMode/PageMode.provider';
import * as React from 'react';
import { Trans } from 'react-i18next';
import { Text, Box } from 'wix-style-react';
import s from './AppTitle.scss';
import { SecondUpgradeSubtitle } from './SecondUpgradeSubtitle';
import { CirclePulseAnimation } from '../CirclePulseAnimation/CirclePulseAnimation';

const variants = {
  fadeIn: {
    opacity: 1,
    x: 0,
    y: 0,
    transition: {
      duration: 0.68,
      ease: [0.075, 0.82, 0.165, 1],
      delay: 0.5,
    },
  },

  exit: {
    opacity: 0,
    x: 0,
    y: 20,
    transition: {
      duration: 0.68,
      ease: [0.075, 0.82, 0.165, 1],
    },
  },
};

const specialDiscountSubtitlePerStep = {
  0: 'Advanced_Plans_plans_page_special_discount_subtitle',
  1: 'Advanced_Plans_subscription_page_special_discount_subtitle',
  2: 'Advanced_Plans_checkout_page_special_discount_subtitle',
};

export interface AppSubtitleProps {
  rootStore: RootStore;
}

const AppSubtitleComp: React.FC<AppSubtitleProps> = ({ rootStore }) => {
  const {
    isSecondUpgrade,
    isChangePlan,
    planType,
    isEditorXSpecialDiscountEnabled,
    currentStep,
    isSepaCountry,
    isInSale,
    isFranchPackagePicker,
    isJapanesePackagePicker,
  } = rootStore.appStore;
  const subtitleKey = isEditorXSpecialDiscountEnabled
    ? specialDiscountSubtitlePerStep[currentStep]
    : planType === PlanType.Enterprise
    ? 'enterprise_plans.page.subtitle'
    : isSepaCountry
    ? 'app.sepaSubtitleText'
    : 'app.subtitleText';
  const { theme } = usePageModeContext();

  const circlePulseAnimationMode = isInSale
    ? PulseCircleAnimationMode.SALE
    : PulseCircleAnimationMode.DEFAULT;
  const showPulse = isFranchPackagePicker || isJapanesePackagePicker;
  return (
    <Text dataHook='page-sub-title' className={classNames(s.subtitle, theme)}>
      {isSecondUpgrade && !isEditorXSpecialDiscountEnabled ? (
        <SecondUpgradeSubtitle />
      ) : isChangePlan ? (
        <Trans i18nKey='change_plan.app_sub_title'>
          Compare plans and choose the one that works best for you
        </Trans>
      ) : (
        <>
          {showPulse && (
            <Box marginRight='10px' marginTop='2px'>
              <CirclePulseAnimation mode={circlePulseAnimationMode} />
            </Box>
          )}
          <Trans i18nKey={subtitleKey}>
            <span className={classNames('colors', s.bold, theme)}></span>
            {subtitleKey}
          </Trans>
        </>
      )}
    </Text>
  );
};

export const AppSubtitleContent = withInjectedRootStore(AppSubtitleComp);

export const AppSubtitleAnimated = () => (
  <motion.div variants={variants} initial='exit' animate='fadeIn'>
    <AppSubtitleContent />
  </motion.div>
);
